import { useMemo } from 'react';

import {
  FraudReviewModalConfirmColor,
  FraudReviewModalKind,
  FraudReviewModalTone,
} from '../fraudReview.constants';

export interface FraudReviewModalConfig {
  testId: string;
  title: string;
  bullets: string[];
  confirmLabel: string;
  confirmColor: FraudReviewModalConfirmColor;
  tone: FraudReviewModalTone;
}

interface Params {
  kind: FraudReviewModalKind | null;
  employeeName: string;
}

const useFraudReviewModalConfig = ({ kind, employeeName }: Params): FraudReviewModalConfig | null =>
  useMemo(() => {
    const name = employeeName || 'this employee';

    switch (kind) {
      case FraudReviewModalKind.Flag:
        return {
          testId: 'fraud-review_flag-modal',
          title: `Flag ${name} for Fraud?`,
          bullets: [
            'All pending and future payments will be held until further review;',
            'Employee will continue to access their accounts without disruption;',
          ],
          confirmLabel: 'Flag for Fraud',
          confirmColor: FraudReviewModalConfirmColor.Red,
          tone: FraudReviewModalTone.Warning,
        };
      case FraudReviewModalKind.Remove:
        return {
          testId: 'fraud-review_remove-modal',
          title: `Remove fraud flag from ${name}?`,
          bullets: [
            'All pending payments will be released and processed;',
            'Future claims will no longer be held for review;',
          ],
          confirmLabel: 'Remove Flag',
          confirmColor: FraudReviewModalConfirmColor.Blue,
          tone: FraudReviewModalTone.Warning,
        };
      case FraudReviewModalKind.Confirm:
        return {
          testId: 'fraud-review_confirm-modal',
          title: `Confirm Fraud for ${name}?`,
          bullets: [
            'All related transactions will be reversed and funds returned to the account balance;',
            `${name}'s username and password will be reset, and they will need to re-register.`,
          ],
          confirmLabel: 'Confirm Fraud',
          confirmColor: FraudReviewModalConfirmColor.Red,
          tone: FraudReviewModalTone.Danger,
        };
      default:
        return null;
    }
  }, [kind, employeeName]);

export default useFraudReviewModalConfig;
